/**
 * Shuffle array using Fisher-Yates algorithm
 */
function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

/**
 * Randomize participant order before each generate/regenerate call, so repeated
 * calls to the server-side solver (amplify/functions/generateAssignments) explore
 * different orderings.
 */
export function randomizeParticipants(participants) {
  return shuffleArray(participants);
}
